import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { ResourceOutsourceSearchRequest } from './ResourceOutsourceSearchRequest';
import { ResourceOutsourceSearchTask } from './ResourceOutsourceSearchTask';
import { buildOptions } from '../../../utils/OptionsManager';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import FormAutocomplete from '../../FormAutocomplete';

export class ResourceOutsource extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            outsources: [],
            outsourcesLoading: false,
        };
    }

    render() {
        const { name, col, disabled } = this.props;
        const { outsources, outsourcesLoading } = this.state;

        return (
            <Field
                col={col}
                name={name}
                label={I18nUtils.tr('TR_SUBCONTRATA')}
                placeholder={I18nUtils.tr('TR_EMPRESA_SUBCONTRATADA')}
                options={outsources}
                loading={outsourcesLoading}
                component={FormAutocomplete}
                onSearch={this.searchOutsources}
                disabled={disabled}
            />
        );
    }

    searchOutsources = (query) => {
        const request = new ResourceOutsourceSearchRequest();
        request.setTerm(query);
        new ResourceOutsourceSearchTask(request)
            .onPreExecution(() => this.setState({ outsourcesLoading: true }))
            .onSuccess((res) => this.setState({ outsources: buildOptions(res.data) }))
            .onFail((error) => Alert.error(error))
            .onPostExecution(() => this.setState({ outsourcesLoading: false }))
            .execute();
    };
}

ResourceOutsource.propTypes = {
    col: PropTypes.string,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

ResourceOutsource.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-outsource/ResourceOutsource.jsx